<template>
  <el-form ref="form" :model="form" :rules="rules" class="form__login" @submit.native.prevent="onSubmit">
    <el-form-item :label="$t('Email')" prop="email">
      <el-input type="email" :placeholder="$t('Email')" v-model="form.email"></el-input>
    </el-form-item>

    <el-form-item :label="$t('Password')" prop="password">
      <el-input type="password" :placeholder="$t('Password')" v-model="form.password"></el-input>
    </el-form-item>

    <el-form-item class="m-t-2 m-b-0">
      <el-button type="primary" native-type="submit" class="w-100" :loading="loading">
        {{ $t('Login') }}
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { DASHBOARD } from '@/router/route-types';

export default {
  name: 'FormLogin',

  data() {
    return {
      form: {
        email: '',
        password: ''
      },
      loading: false,
      rules: {
        email: [
          {
            required: true,
            message: this.$t('Please fill out all required fields'),
            trigger: 'blur'
          },
          {
            type: 'email',
            message: this.$t('Please enter valid email address'),
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: this.$t('Please fill out all required fields'),
            trigger: 'blur'
          }
        ]
      }
    };
  },

  methods: {
    onSubmit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.signIn();
        } else {
          return false;
        }
      });
    },

    signIn() {
      console.log('signIn');
      this.loading = true;

      this.$store
        .dispatch('auth/LOGIN', this.form)
        .then(result => {
          this.loading = false;

          console.log('signIn', result);

          // Incorrect authentification
          if (result.code && result.message) {
            this.$message({
              message: result.message,
              type: 'error',
              showClose: true,
              duration: 10000
            });

            return false;
          }

          // Redirect to main page
          this.$router.push({ name: DASHBOARD });
        })
        .catch(err => {
          this.loading = false;

          console.log('auth error', err);
        });
    }
  }
};
</script>
